import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin, Alert, Typography, Card } from 'antd';
import parse from 'html-react-parser';

const { Title, Paragraph } = Typography;

const NewsDetail = () => {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [cleanHtml, setCleanHtml] = useState('');

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await fetch(`http://localhost:8080/api/news/${id}`);
        if (!res.ok) throw new Error('خطا در دریافت خبر');
        const data = await res.json();
        setNews(data);

        if (typeof window !== 'undefined' && data.passage) {
          const DOMPurify = require('dompurify');
          setCleanHtml(DOMPurify.sanitize(data.passage));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchNews();
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: 80 }}>
        <Spin size="large" tip="در حال بارگذاری..." />
      </div>
    );
  }

  if (error) {
    return <Alert message={`خطا: ${error}`} type="error" showIcon style={{ margin: 20 }} />;
  }

  if (!news) {
    return <Alert message="خبر یافت نشد" type="warning" showIcon style={{ margin: 20 }} />;
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f0f2f5', padding: 24, direction: 'rtl' }}>
      <Card
        style={{ maxWidth: 1100, margin: '0 auto', borderRadius: 8 }}
        bodyStyle={{ padding: '24px' }}
      >
        <Title level={2} style={{ marginBottom: 16 }}>{news.title}</Title>

        {news.description && (
          <Paragraph style={{ fontSize: 16, color: '#333' }}>
            {news.description}
          </Paragraph>
        )}

        {cleanHtml && (
          <div style={{ marginTop: 24 }}>
            <Title level={5} style={{ marginBottom: 12 }}>متن کامل خبر:</Title>
            <div
              style={{
                backgroundColor: '#fafafa',
                padding: 16,
                borderRadius: 8,
                direction: 'rtl',
                textAlign: 'right',
              }}
              className="news-content"
            >
              {parse(cleanHtml)}
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};

export default NewsDetail;
